(ns frontend.view.nev.oppo.events
  (:require
   [frontend.view.modals.curtains.pass-curtain.view :as pass-curtain]
   [frontend.view.modals.events :as modals]
   [frontend.state.current-session :as session]
   [frontend.view.modals.curtains.put-on-hold-curtain.view :as put-on-hold-curtain]
   [frontend.actions.deal :as deal-actions]
   [frontend.logging :as logging]
   [frontend.view.entity-actions.oppo :as entity-actions-oppo]
  ))

(defn start-pass!
  [entity]
  (let [oppo-id (:db/id entity)]
    (when (session/is-mobile?)
      (.scrollTo js/window 0 0))
    (modals/open-modal!
     pass-curtain/modal-key
     {:oppo-id oppo-id})))

(defn start-put-on-hold!
  [oppo]
  (let [oppo-id (:db/id oppo)]
    (when (session/is-mobile?)
      (.scrollTo js/window 0 0))
    (modals/open-modal!
     put-on-hold-curtain/modal-key
     {:oppo-id oppo-id})))

(defn start-to-portfolio!
  [oppo]
  (entity-actions-oppo/open-portfolio-modal oppo))


(defn resurrect!
  [oppo-id]
  (let [data {:oppo-id oppo-id}
        on-success! (fn [_]
                        ;(end-edit!) ;;TODO: @kauranen - close all modals in this flow!
                    )
        on-error! (partial logging/error "resurrect!")]
    (deal-actions/*->resurrect data on-success! on-error!)))
